export enum OrdersRoute {
  ORDERS_LIST = '/orders',
  ADD_ORDER = '/orders/add',
  IMPORT_RESULT = '/orders/import',
  ORDER_CARD = '/orders/:uuid',
  EDIT_ORDER = '/orders/:uuid/edit',
  ASSIGN_MANUAL_ROUTE = '/orders/:uuid/manual-route',
}
